export const MODES = {
  BLANKS: "blanks",
  MADE: "made"
};

export const NECK_LINE_MODES = {
  DEFAULT: "default",
  CUSTOM: "custom"
};

export const PRICES = {
  DEFAULT: 4.99,
  FRONT_AND_BACK: 7.99,
  MADE_DEDICATED_FRONT_AND_BACK: 3.0
};

export const SURFACES = {
  FRONT: "front",
  BACK: "back",
  FRONT_LEFT_CHEST: "front_left_chest"
};

export const SIDES = {
  FRONT: "front",
  BACK: "back"
};

export const MADE_SAMPLES_SIZE = "Large";

export const MADE_SESSION_RECORD_PERCENT = 10;

export const NECK_LINE_STEP = 0.25;

export default {};
